export default __webpack_public_path__ + "static/mastermatchmaker_screen_2-3bd838b4154fe2177b75e7185089edea.svg";